﻿import * as d3 from "d3";
import uid from "./uid";
import thickLine from "./thick-line";
import { color, getFormat } from "./helpers";

const getColorByLink = (edgeColor) => {
    return (d) => {
        //if (edgeColor === "none") return "#aaa";
        //else if (edgeColor === "path") return d.uid;
        //else if (edgeColor === "input") return color(d.source);
        //else return color(d.target);
        return color(d.source);
    };
};

const getLinkId = (d) => `${d.uid.id}-path`;

function reorderLinks(nodes) {
    function ascendingBreadth(a, b) {
        return a.y0 - b.y0;
    }
    function ascendingSourceBreadth(a, b) {
        return ascendingBreadth(a.source, b.source) || a.index - b.index;
    }
    function ascendingTargetBreadth(a, b) {
        return ascendingBreadth(a.target, b.target) || a.index - b.index;
    }

    for (const { sourceLinks, targetLinks } of nodes) {
        sourceLinks.sort(ascendingTargetBreadth);
        targetLinks.sort(ascendingSourceBreadth);
    }
}

let redrawLinksInternal;
const redrawLinksInternalGenerator = (sankeyGenerator, data) => {
    return () => {
        reorderLinks(data.nodes);
        sankeyGenerator.update(data);

        // redraw
        for (const element of document.getElementsByClassName("gradient")) {
            d3.select(element)
                .attr("x1", (d) => d.source.x1)
                .attr("x2", (d) => d.target.x0);
        }
        for (const element of document.getElementsByClassName("link")) {
            d3.select(element).attr("d", thickLine());
        }
    };
};

export const redrawLinks = function () {
    return redrawLinksInternal.apply(this, arguments);
};

export const create = ({
    container,
    data,
    edgeColor,
    units,
    sankeyGenerator
}) => {
    const format = getFormat(units);
    const { links } = data;
    //console.log('links');
    //console.log(links);
    const link = container
        .append("g")
        .attr("fill", "none")
        .attr("stroke-opacity", 0.5)
        .selectAll("g")
        .data(links)
        .join("g")
        .style("mix-blend-mode", "multiply");

    if (edgeColor === "path") {
        const gradient = link
            .append("linearGradient")
            .attr("id", (d) => {
                d.uid = uid("link");

                return d.uid.id;
            })
            .attr("class", "gradient")
            .attr("gradientUnits", "userSpaceOnUse")
            .attr("x1", (d) => d.source.x1)
            .attr("x2", (d) => d.target.x0);

        gradient
            .append("stop")
            .attr("offset", "0%")
            .attr("stop-color", (d) => color(d.source));

        gradient
            .append("stop")
            .attr("offset", "50%")
            .attr("stop-color", (d) => color(d.target));
    }

    link
        .append("path")
        .attr("class", "link")
        .attr("id", getLinkId)
        .attr("d", thickLine())
        .attr("stroke", getColorByLink(edgeColor))
        .attr("fill", getColorByLink(edgeColor))
        .attr("stroke-opacity", 0.5);

    link
        .append("title")
        .text((d) => `${d.source.name} → ${d.target.name}\n${format(d.value)}`);

    redrawLinksInternal = redrawLinksInternalGenerator(sankeyGenerator, data);

    return link;
};
